import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';
import { FaPlus, FaWindowClose } from 'react-icons/fa';

import NavTabs from 'App/components/NavTabs/NavTabs';
import InsuranceFormArea from 'App/components/PatientInsurance/InsuranceFormArea';
import TherigyInfoMessage from 'App/components/TherigyInfoMessage/TherigyInfoMessage';
import withFormikFields, { fieldHelpersPropType } from 'Shared/form/withFormikFields';
import SectionTitleStyle from './SectionTitleStyle';

const PatientInsuranceForm = ({
    validateForm,
    fieldValues: { patientInsurance },
    fieldHelpers: {
        patientInsurance: { setValue: setPatientInsurance },
    },
}) => {
    return (
        <>
            <SectionTitleStyle>
                <h2>Insurance Plans</h2>
                <Button
                    variant="link"
                    onClick={() => {
                        setPatientInsurance([...patientInsurance, {}]);
                        setImmediate(() => validateForm());
                    }}
                >
                    <FaPlus /> Add Insurance Plan
                </Button>
            </SectionTitleStyle>

            {!patientInsurance.length ? (
                <TherigyInfoMessage message="There are no insurance plans attached to this patient." />
            ) : (
                <NavTabs
                    items={patientInsurance}
                    renderNavTab={(item, index) => (
                        <>
                            <span>{item.name || `Plan ${index + 1}`} </span>
                            <FaWindowClose
                                onClick={() => {
                                    const newInsurance = [...patientInsurance];
                                    newInsurance.splice(index, 1);
                                    setPatientInsurance(newInsurance);
                                    setImmediate(() => validateForm());
                                }}
                            />
                        </>
                    )}
                    renderPaneContent={(item, index) => (
                        <InsuranceFormArea fieldPrefix={`patientInsurance[${index}]`} insuranceId={item.id} />
                    )}
                />
            )}
        </>
    );
};

PatientInsuranceForm.propTypes = {
    validateForm: PropTypes.func.isRequired,
    fieldValues: PropTypes.shape({
        patientInsurance: PropTypes.arrayOf(PropTypes.shape({})),
    }).isRequired,
    fieldHelpers: fieldHelpersPropType.isRequired,
};

export default withFormikFields({ WrappedComponent: PatientInsuranceForm, fieldNames: ['patientInsurance'] });
